<template>
  <div>
    <hero-bar>
      Add Load
    </hero-bar>
    <section class="section is-main-section">
      <card-component title="" icon="ballot" class="addJob">
        <form @submit.prevent="submit">
          <br>
          <div class="columns is-mobile is-multiline">
          <b-field label="" class="has-check">
          <radio-picker :options="{one:'Pickup From Client',two:'Deliver To Client', three:'Farm To Farm'}" v-model="form.radio"></radio-picker>
        </b-field>
        </div>
        <br>
        <div class="columns is-mobile is-multiline">
          <b-select style="width:95%" placeholder="Select truck">
            <option v-for="(truck, index) in trucks" :key="index" :value="truck.name">
              {{ truck.description }}
            </option>
          </b-select>
        </div>
        <br>
        <div class="columns is-mobile is-multiline">
          <b-field label="Charge To" custom-class="labelCharge" horizontal>
              <b-input v-model="form.charge" required />
          </b-field>
          </div>
          <br>
          <div class="columns is-mobile is-multiline">
          <b-field label="Pickup" horizontal>
              <b-input v-model="form.pickup" required class="mr-3" />
          </b-field>
          <b-field label="Desination" horizontal>
            <b-input v-model="form.destination" required />
          </b-field>
          </div>
          <br>
          <div class="columns is-mobile is-multiline">
          <b-field label="Requested Pickup Time" custom-class="labelRequest" horizontal>
            <b-datetimepicker
                rounded
                placeholder="Click to select..."
                icon="calendar-today"
                horizontal-time-picker
                v-model="form.pickupDate"
                required>
            </b-datetimepicker>
          </b-field>
          <b-field label="Requested Delivery Time" custom-class="labelRequestDelivery" horizontal>
            <b-datetimepicker
                rounded
                placeholder="Click to select..."
                icon="calendar-today"
                horizontal-time-picker
                v-model="form.deliveryDate"
                required>
            </b-datetimepicker>
          </b-field>
          </div>
          <br>
          <div class="columns is-mobile is-multiline">
          <b-field label="Customer" horizontal>
            <b-input v-model="form.notes" required class="mr-3" />
          </b-field>
          <b-field label="Customer Phone" custom-class="labelCustomer" horizontal>
            <b-input v-model="form.notes" required />
          </b-field>
          </div>
          <hr>
          <b-table :data="loads" :columns="columns" @click="selectJob" @check="myEventx" checkable :header-checkable=false></b-table>
          <hr>
          <b-field horizontal>
            <b-field grouped>
              <div class="control">
                <b-button @click="newProduct">New</b-button>
              </div>
              <div class="control">
                <b-button type="is-primary" @click="editProduct">Edit</b-button>
              </div>
              <div class="control">
                <b-button type="is-primary" @click="deleteProduct">Delete</b-button>
              </div>
            </b-field>
          </b-field>
          <hr>
          <b-field horizontal>
            <b-field grouped>
              <div class="control">
                <b-button native-type="submit" type="is-primary">Submit</b-button>
              </div>
              <div class="control">
                <b-button type="is-primary is-outlined" @click="reset">Reset</b-button>
              </div>
            </b-field>
          </b-field>
          </form>
      </card-component>
    </section>
</div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import mapValues from 'lodash/mapValues'
import RadioPicker from '@/components/RadioPicker'
import axios from 'axios'
import HeroBar from '@/components/HeroBar'
export default {
  name: 'Forms',
  components: { HeroBar, RadioPicker, CardComponent },
  data () {
    return {
      isLoading: false,
      selected: null,
      statuses: [
        'Booked',
        'Scheduled',
        'Loaded',
        'Delivered',
        'Complete',
        'Invoiced'
      ],
      loads: [],
      columns: [{ field: 'id', label: 'ID', width: '40', numeric: true },
        { field: 'qty', label: 'Qty' },
        { field: 'product', label: 'Product' },
        { field: 'unit', label: 'Unit', centered: true },
        { field: 'notes', label: 'Notes' },
        { field: 'rate', label: 'Rate' },
        { field: 'estKm', label: 'Est KM' },
        { field: 'estWeight', label: 'Est Weight' },
        { field: 'status', label: 'Status' }
      ],
      showAddModal: false
    }
  },
  computed: {
  },
  methods: {
    submit () {
      var x = ''
      // for (x in this.dataC) {
      //  alert(this.dataC[x].product)
      // }
      for (x in this.data) {
        alert(this.data[x].first_name)
      }
    },
    reset () {
      this.form = mapValues(this.form, item => {
        if (item && typeof item === 'object') {
          return []
        }
        return null
      })

      this.$buefy.snackbar.open({
        message: 'Reset successfully',
        queue: false
      })
    },
    newProduct () {
      this.$store.commit('setQty', 0)
      this.$store.commit('setStatus', '')
      this.$store.commit('setProduct', '')
      this.$store.commit('setUnit', '')
      this.$store.commit('setNotes', '')
      this.$store.commit('setRate', 0)
      this.$store.commit('setKm', 0)
      this.$store.commit('setWeight', 0)
      this.openAddModal()
    },
    selectJob (record) {
      this.router.push({ path: 'job', query: { id: record.id } })
    },
    deleteProduct () {
      alert('gg')
      this.$store.commit('setQty', 0)
      this.$store.commit('setStatus', '')
      this.$store.commit('setProduct', '')
      this.$store.commit('setUnit', '')
      this.$store.commit('setNotes', '')
      this.$store.commit('setRate', 0)
      this.$store.commit('setKm', '')
      this.$store.commit('setWeight', '')
    },
    async getLoads () {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(this.$store.state.apiUrl + 'lookup/vehicle', {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
        var i = 0
        for (i = 0; i < data.length; i++) {
          var statusName = ''
          //  statusName = this.status.find(x => x.id === data[i].status).name
          this.loads.push({
            date: data[i].scheduledDate, driver: data[i].driverName, truck: data[i].truckName, origin: data[i].pickupAddress.addressName, dest: data[i].destinationAddress.addressName, qty: data[i].qty, price: data[i].priceCharged, status: statusName, id: data[i].bookingId
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  created () {
    this.getLoads()
  }
}
</script>
